import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { startPostHog, capturePageview } from '../lib/analytics/posthog';

/**
 * Starts PostHog once and sends a pageview per route change. Lives inside the
 * Router because it needs useLocation; renders nothing.
 */
const PostHogTracker: React.FC = () => {
  const { pathname, search } = useLocation();
  // StrictMode runs effects twice in development, which sent every pageview
  // twice. Remembering the last URL sent makes the capture idempotent whatever
  // re-runs the effect.
  const lastSent = useRef<string | null>(null);

  useEffect(() => {
    startPostHog();
  }, []);

  useEffect(() => {
    const url = pathname + search;
    if (lastSent.current === url) return;
    lastSent.current = url;
    capturePageview(pathname, search);
  }, [pathname, search]);

  return null;
};

export default PostHogTracker;
